import { render, staticRenderFns } from "./ReportLawyersGrid.vue?vue&type=template&id=32fd2c52"
import script from "./ReportLawyersGrid.vue?vue&type=script&lang=js"
export * from "./ReportLawyersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports